export const environment = {
  production: true,
  localhost: false,
  apiUrl: '//fresh.orderpod.app',
  ngswEnabled: false,
  privateKey: '0rd3rP0dpr0duct10nfr0nt3nd139',
  configuration: 'fresh',
  sentryDsn:
    'https://50061d5ec8d944acb6005a30986bcedb@o4504236582305792.ingest.sentry.io/4504236584861699',
  freshUserIds: [
    // Andrea Rizzo - andrear
    '642e8e3f31163940ec0425bc',
    // Luca Roman - luca.evo
    '5fb27ccfe7138b34f0ac525a',
    // Mirko Bisetto -  mirko.evo
    '602c13ae504db6345cffbb5b',
    // Samantha Piccoli - samantha.evo
    '63e25bbc522f6d0954bb322a',
    // Giacomo Gregoletto - greguz
    '62728a35a81bf39d1e5c023c',
    // Massimiliano Romanello - massimiliano.romanello
    '6481d436ed7a521c7d9a0e69',
    // Negatu Moro - negatu.moro
    '65f07cbf079450b47aa0f6ca',
    // Alessandro Gobbo - alessandro.evo
    '5fb27d99e7138b34f0ac5281',
  ],
}
